import React from "react";
import { Link } from "react-router-dom";
/* Others */
import logo from "../../../assets/logo-latam-white.png";
/* Bootstrap Components */
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { FaArrowRight } from "react-icons/fa";
import Modal from "react-modal";
import { FaRegWindowClose } from "react-icons/fa";
/* Styles */
import {
  StyledRowFooter,
  StyledSupport,
  StyledNewsletterContact,
  StyleUlCredits,
} from "./styled";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

function Footer() {
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <Container fluid={true}>
      <StyledRowFooter style={{ backgroundColor: "#354052 !important" }}>
        <Col className="col-container">
          <Row>
            <Col xs={12} sm={12} md={12} lg={3}>
              <Row>
                <Col lg={12}>
                  <img
                    src={logo}
                    className="img-thumbnail"
                    alt="logo"
                    style={{ marginLeft: "5px" }}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={12} md={3} lg={12}>
                  <StyledSupport>
                    Contactanos a:
                    <br />
                    latamchequea@chequeado.com
                  </StyledSupport>
                </Col>
              </Row>
            </Col>
            <Col xs={12} sm={12} md={6} lg={2}>
              <StyledNewsletterContact>
                <p>
                  Suscribete a nuestro
                  <br /> newsletter
                </p>
                <button>
                  <a
                    href="https://mailchi.mp/2092e091887f/newsletter-latamchequea"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Suscribirme
                  </a>
                </button>
                <span>
                  <FaArrowRight />
                </span>
              </StyledNewsletterContact>
            </Col>
            <Col xs={12} sm={12} md={6} lg={3}>
              <StyledNewsletterContact>
                <p>
                  ¿Tienes un medio y quieres ser parte de <br /> LatamChequea?
                </p>
                <button>
                  <a href="mailto:latamchequea@chequeado.com">Contactate</a>
                </button>
                <span>
                  <FaArrowRight />
                </span>
              </StyledNewsletterContact>
            </Col>
            <Col xs={6} sm={12} md={6} lg={1}>
              <StyledNewsletterContact>
                <p style={{ marginBottom: "21px" }}>
                  Preguntas
                  <br /> frecuentes
                </p>
                <Link
                  to={"/preguntas-frecuentes"}
                  style={{ color: "#000" }}
                  rel="noopener noreferrer"
                >
                  <span>
                    <FaArrowRight style={{ color: "white" }} />
                  </span>
                </Link>
              </StyledNewsletterContact>
            </Col>
            <Col xs={6} sm={12} md={6} lg={1}>
              <StyledNewsletterContact>
                <p style={{ marginBottom: "21px" }}>
                  LatamChequea
                  <br /> en los medios
                </p>
                <Link
                  to={"/latamchequea-enmedios"}
                  style={{ color: "#000" }}
                  rel="noopener noreferrer"
                >
                  <span>
                    <FaArrowRight style={{ color: "white" }} />
                  </span>
                </Link>
              </StyledNewsletterContact>
            </Col>

            <Col
              xs={12}
              sm={12}
              md={12}
              lg={1}
              className="col-copy"
              style={{ justifyContent: "center" }}
            >
              <StyledNewsletterContact>
                <p style={{ marginBottom: "21px" }}>
                  <a onClick={openModal}>
                    Créditos <br />
                  </a>
                </p>
                <span>
                  <FaArrowRight
                    onClick={openModal}
                    style={{ cursor: "pointer", color: "white" }}
                  />
                </span>
              </StyledNewsletterContact>
            </Col>
            <Modal
              isOpen={modalIsOpen}
              onRequestClose={closeModal}
              style={customStyles}
              contentLabel="Example Modal"
            >
              <Row>
                <Container>
                  <Col lg={12} className="mx-auto">
                    <Row>
                      <Col style={{ textAlign: "right" }}>
                        <FaRegWindowClose
                          onClick={closeModal}
                          style={{
                            color: "#354052",
                            fontSize: "20px",
                            marginRight: "5px",
                            verticalAlign: "sub",
                            cursor: "pointer",
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        style={{
                          textAlign: "center",
                          marginBottom: "20px",
                          fontWeight: "bold",
                          color: "#dc4157",
                        }}
                      >
                        Créditos
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={12} className="mx-auto">
                        <Row>
                          <Col lg={12}>
                            <StyleUlCredits>
                              <li>
                                Directora de Impacto y Nuevas Iniciativas |{" "}
                                <b>Olivia Sohr</b>
                              </li>
                              <li>
                                Coordinador de Proyectos Especiales |{" "}
                                <b>Martín Slipczuk</b>
                              </li>
                              <li>
                                Líder de Proyectos | <b>Sebastián Lanaro</b>
                              </li>
                              <li>
                                Desarrollo | <b>Pilar Castro</b>
                              </li>

                              <li>
                                Coordinación de producto | <b>Ariel Tiferes</b>
                              </li>
                              <li>
                                Diseño | <b>Matías Severo</b>
                              </li>
                              <hr />
                              <li>
                                Director Ejecutivo y Periodístico |{" "}
                                <b>Pablo M. Fernández</b>
                              </li>
                            </StyleUlCredits>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Container>
              </Row>
            </Modal>
          </Row>
        </Col>
      </StyledRowFooter>
    </Container>
  );
}

export default Footer;
